import React, { useEffect, useRef, useState } from 'react';
import { loadGoogleMapsAPI } from '../googleMapsLoader';
import './comp_location_search.css';

export const Comp_Location_Search = () => {
  const inputRef = useRef(null);
  const [output, setOutput] = useState("");
  const [isGoogleLoaded, setIsGoogleLoaded] = useState(false);
  const autocompleteRef = useRef(null);

  const getLocationAccess=()=>{
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            //alert(JSON.stringify(position));
            localStorage.setItem("location",JSON.stringify(position));
            
            // setLocation({
            //   latitude: position.coords.latitude,
            //   longitude: position.coords.longitude,
            // });
          },
          (error) => {
            // setError(error.message);
          }
        );
      } else {
        //setError("Geolocation is not supported by this browser.");
      }
}

  useEffect(() => {
    loadGoogleMapsAPI()
      .then(() => {
        //getLocationAccess();
       
        setIsGoogleLoaded(true);
        initializeAutocomplete();
        //getCurrentLocation();
        getCurrentLocationWithCityState();
      })
      .catch((error) => {
        console.error('Google Maps API failed to load:', error);
        setOutput("Error loading location services.");
      });
  }, []);

  useEffect(()=>{
   
  },[])

  const initializeAutocomplete = () => {
    if (!inputRef.current || !window.google || !window.google.maps.places) return;

    autocompleteRef.current = new window.google.maps.places.Autocomplete(inputRef.current, {
      types: ['geocode'],
    });

    

    autocompleteRef.current.addListener('place_changed', () => {
      
      const place = autocompleteRef.current.getPlace();
      const address = place.formatted_address || place.name || "Unknown place";
      localStorage.setItem("selectedLocation", address);
      window.location.reload();
      //setOutput(`Selected: ${address}`);
    });
  };

  const getCurrentLocationWithCityState=()=>{
    if (!navigator.geolocation) {
      setOutput("Geolocation not supported.");
      return;
    }

    if (!isGoogleLoaded) {
      //setOutput("Google Maps not ready.");
      //return;
    }

    //setOutput("Locating…");
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        const latlng = { lat: latitude, lng: longitude };
        const geocoder = new window.google.maps.Geocoder();
        //alert("i m in posiotn");

        geocoder.geocode({ location: latlng }, (results, status) => {
          if (status === "OK" && results[0]) {
            let city = "";
            let state = "";
        
            const components = results[0].address_components;
            components.forEach((component) => {
              if (component.types.includes("locality")) {
                city = component.long_name;
              }
              if (component.types.includes("administrative_area_level_1")) {
                state = component.long_name;
              }
            });
        
            // Fallback if locality missing, use district-level info
            if (!city) {
              const district = components.find(c =>
                c.types.includes("administrative_area_level_2")
              );
              if (district) city = district.long_name;
            }
        
            // Only set "City, State" in the input
            if (inputRef.current) {
             
              inputRef.current.value = `${city}${city && state ? ", " : ""}${state}`;
              if(!localStorage.getItem("selectedLocation")){

                 localStorage.setItem("selectedLocation",  inputRef.current.value );
      window.location.reload();
              }
              
            }
          }

          const savedLocation = localStorage.getItem("selectedLocation");
          if (savedLocation) {
            // If you are using a text field
            if (inputRef.current) {
              inputRef.current.value = savedLocation;

              

            }
        
            // If you are managing via state
            // setOutput(`Selected: ${savedLocation}`);
          }
        });
      },
      (error) => {
        const messages = {
          1: "Permission denied.",
          2: "Position unavailable.",
          3: "Timeout.",
        };
        setOutput(messages[error.code] || "Unknown error.");
      },
      {
        timeout: 10000,
        enableHighAccuracy: true,
        maximumAge: 300000,
      }
    );
  }

  const getCurrentLocation = () => {
    if (!navigator.geolocation) {
      setOutput("Geolocation not supported.");
      return;
    }

    if (!isGoogleLoaded) {
      setOutput("Google Maps not ready.");
      //return;
    }

    setOutput("Locating…");
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        const latlng = { lat: latitude, lng: longitude };
        const geocoder = new window.google.maps.Geocoder();
        //alert("i m in posiotn");

        geocoder.geocode({ location: latlng }, (results, status) => {
          if (status === "OK" && results[0]) {
            //alert("i m in current location");
            const address = results[0].formatted_address;
            inputRef.current.value = address;
            setOutput("");
            //setOutput(`Your location: ${address}`);
          } else {
            //setOutput(`Unable to retrieve address. Status: ${status}`);
          }
        });
      },
      (error) => {
        const messages = {
          1: "Permission denied.",
          2: "Position unavailable.",
          3: "Timeout.",
        };
        setOutput(messages[error.code] || "Unknown error.");
      },
      {
        timeout: 10000,
        enableHighAccuracy: true,
        maximumAge: 300000,
      }
    );

  };

  return (
    <div className="location-search-wrapper mx-auto max-w-xl">
      <div className="d-flex items-center shadow-sm border rounded overflow-hidden">
        <button
          type="button"
          className="btn btn-primary"
          onClick={getCurrentLocationWithCityState}
          disabled={!isGoogleLoaded}
          title={!isGoogleLoaded ? "Loading location..." : "Get current location"}
        >
          <i className="fa fa-crosshairs fa-2xl"></i>
        </button>
        <input
          id="_search_location_name"
          name="_search_location_name"
          ref={inputRef}
          type="text"
          className="w-full px-4 py-3 border-0 focus:outline-none"
          placeholder="Enter location here"
        />
      </div>
      {/* <div className="mt-2 text-gray-500 text-sm">{output}</div> */}
    </div>
  );
};

export default Comp_Location_Search;
